import React from 'react';
import { Paragraph } from 'common-components/typography';
import _ from 'lodash';
import { BookingType, ShiftSlotStatus } from 'utilities/enum-utils';
import { Worker } from './types';

interface AssignWorkerStep12Props {
  selectedWorker: Worker | null;
  bookingType: BookingType | undefined;
  shiftSlotStatus: ShiftSlotStatus | null;
}

export const AssignWorkerStep12 = ({ selectedWorker, bookingType, shiftSlotStatus }: AssignWorkerStep12Props) => {
  return (
    <div className='mt-small'>
      <Paragraph>
        You have successfully assigned{' '}
        <b>
          {selectedWorker?.firstName} {selectedWorker?.lastName}
        </b>{' '}
        as team member for this {bookingType === BookingType.BOOKING ? 'booking' : 'activity record'}
        {shiftSlotStatus === ShiftSlotStatus.CHECKED_OUT &&
          ` and changed the time of this ${
            bookingType === BookingType.ACTIVITY_RECORD ? 'activity record' : 'booking'
          }`}
        .
      </Paragraph>
    </div>
  );
};
